import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useAppStore = defineStore('app', () => {
	const seoUser = ref(true);
	const xServeTrack = ref<string | null | undefined>(null);
	const isUsingAdBlocker = ref(false);

	const isSeoUser = computed(() => {
		return seoUser.value;
	});

	function setSeoUser(value: boolean) {
		seoUser.value = value;
	}

	function setXServeTrack(value: string | null | undefined) {
		xServeTrack.value = value;
	}

	function setIsUsingAdBlocker(value: boolean) {
		isUsingAdBlocker.value = value;
	}

	return {
		seoUser,
		xServeTrack,
		isUsingAdBlocker,
		isSeoUser,
		setSeoUser,
		setXServeTrack,
		setIsUsingAdBlocker,
	};
});
